<template>
  <div :class="validationContainerClass">
    <v-validate
      :rules="rules"
      :vid="name"
      v-slot="{ errors, classes }"
      :name="label"
    >
      <div class="form-group">
        <label :for="id"
          >{{ label }}
          <slot name="actionbtn"/>

          <div v-if="isRequired" class="is-required">
            <i class="fas fa-star-of-life"></i></div
        ></label>
        <textarea
          :id="inputID"
          :name="name"
          :ref="name"
          :type="type"
          :rows="10"
          :class="`${inputClass} ${classes.invalid ? 'is-invalid' : ''}`"
          :placeholder="placeHolder"
          v-model="content"
          @input="handleInput(content)"
        />
      </div>
      <span class="invalid-feedback">{{ errors[0] }}</span>
    </v-validate>
  </div>
</template>
<script>
import InputCommons from "./InputCommons.vue";
export default {
  extends: InputCommons,
};
</script>
